const c = {
  name: "Credentials",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21.2,15c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,13.7,21.2,14.3,21.2,15z"
			/>
		<path class="st0" d="M26,9h-2V8c0-2.2-1.8-4-4-4s-4,1.8-4,4v1h-2v12h12V9z M16,19v-8h8v8H16z M22,8v1h-4V8c0-1.1,0.9-2,2-2
			S22,6.9,22,8z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v19c0,1.7,1.3,3,3,3v4.2c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3
			c0-1.3-0.8-2.4-2-2.8V25h6v9.2c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V25h6v4.2
			c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V25h6v9.2c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3
			c1.7,0,3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V25h6v4.2c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V25
			c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h34c0.6,0,1,0.4,1,1v19c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V3z M4,31
			c0.6,0,1,0.4,1,1s-0.4,1-1,1c-0.6,0-1-0.4-1-1S3.4,31,4,31z M19,32c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S19,32.6,19,32z M36,31
			c0.6,0,1,0.4,1,1s-0.4,1-1,1c-0.6,0-1-0.4-1-1S35.4,31,36,31z M11,37c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1s-0.4,1-1,1
			C11.4,38,11,37.6,11,37z M28,36c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S27.4,36,28,36z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Credentials
};
